import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type NoPoliciesAttachedConfig = typeof NoPoliciesAttachedConfig._.Config;

export const NoPoliciesAttachedConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.NoPoliciesAttached,
  configSchema: z.object({}),
});
